import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateOverlayDocument } from './update.generated';

export const useUpdateOverlay = (options: ApiOptions<typeof UpdateOverlayDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateOverlayDocument, {
    ...useNotifications(UpdateOverlayDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.overlays.update_success'),
    }),

    ...options,
  });
};
